<script setup>
import { computed } from 'vue'
import Button from 'primevue/button'
import { FORM_COLOR_MAP } from '../../../composables/useReservationsCalendar.js'

const props = defineProps({
    reservation: { type: Object, required: true },
    // { id, name, formName, formColor, timeStart, timeEnd, when, status }
})

const emit = defineEmits(['accept', 'reject'])

const color = computed(() => FORM_COLOR_MAP[props.reservation.formColor] ?? '#6B7280')

const timeTxt = computed(() => {
    if (props.reservation.timeStart) {
        return `${props.reservation.timeStart}${props.reservation.timeEnd ? '–' + props.reservation.timeEnd : ''}`
    }
    return props.reservation.when ?? ''
})
</script>

<template>
    <div class="flex items-center gap-3 py-3 border-b border-gray-100 dark:border-neutral-800 last:border-b-0">
        <div class="w-0.5 h-[34px] rounded-full flex-shrink-0" :style="{ background: color }"/>
        <div class="flex-1 min-w-0">
            <div class="text-[13px] font-semibold text-gray-900 dark:text-white truncate">{{ reservation.name }}</div>
            <div class="text-[11.5px] text-gray-400 dark:text-neutral-500 mt-0.5">{{ reservation.formName }} · {{ timeTxt }}</div>
        </div>
        <div class="flex gap-1 flex-shrink-0">
            <Button
                icon="pi pi-check"
                severity="success"
                size="small"
                text
                rounded
                v-tooltip.top="$t('reservations.btn_confirm')"
                @click="emit('accept', reservation.id)"
            />
            <Button
                icon="pi pi-times"
                severity="danger"
                size="small"
                text
                rounded
                v-tooltip.top="$t('common.reject')"
                @click="emit('reject', reservation.id)"
            />
        </div>
    </div>
</template>
